import { React, useState, useRef, useEffect } from "react";
import { useLocation,Link } from "react-router-dom";
import { isMobile } from "react-device-detect";
import { useDispatch, useSelector } from "react-redux";
import { MessageCircle } from "lucide-react";

const WHATSAPP_SUPPORT_PATH = "/agent/accounts/whatsapp-support";

const NavButton = () => {
  const userInfo = useSelector((state) => state.userStore);
  console.log("userInfo->", userInfo);
  const [activeTab, setActiveTab] = useState(0);
  const location = useLocation();

  const loginUserName = userInfo?.data?.uname;
  const UserRole = userInfo?.data?.user_role;
  const allowAutoDeposit = Number(userInfo?.data?.allow_auto_deposit) === 1;

  useEffect(() => {
    var pathname = location.pathname;
    if (pathname != null && pathname != undefined) {
      setActiveTab(pathname);
    }
  }, [location.pathname]);

  return (
    <div className="card">
      <div className="card-header">
        <i className="fa fa-filter"></i>
        <strong className="site_family">Report Type</strong>
      </div>
      <div
        className="card-body reportmenubuttons"
        style={{
          textAlign: isMobile ? "center" : "left",
          marginTop: "15px",
          marginBottom: "15px",
          marginLeft: isMobile ? "0px" : "10px"
        }}
      >
        <Link
          to="/agent/book-detail"
          className={
            activeTab === "/agent/book-detail"
              ? "btn btn-primary"
              : "btn btn-outline-primary"
          }
        >
          <span className="site_family">Book Detail</span>
        </Link>

        <Link
          to="/agent/book-detail2"
          style={{ marginLeft: "3px" }}
          className={
            activeTab === "/agent/book-detail2"
              ? "btn btn-primary"
              : "btn btn-outline-primary"
          }
        >
          <span className="site_family">Book Detail 2</span>
        </Link>

        <Link
          to="/agent/daily-pl"
          style={{ marginLeft: "0px" }}
          className={
            activeTab === "/agent/daily-pl"
              ? "btn btn-primary"
              : "btn btn-outline-primary"
          }
        >
          <span className="site_family">Daily PL</span>
        </Link>

        <Link
          to="/agent/daily-reports"
          style={{ marginLeft: "5px" }}
          className={
            activeTab === "/agent/daily-reports"
              ? "btn btn-primary"
              : "btn btn-outline-primary"
          }
        >
          <span className="site_family">Daily Report</span>
        </Link>

        <Link
          to="/agent/final-sheet"
          style={{ marginLeft: "5px" }}
          className={
            activeTab === "/agent/final-sheet"
              ? "btn btn-primary"
              : "btn btn-outline-primary"
          }
        >
          <span className="site_family">Final Sheet</span>
        </Link>

        <Link
          to="/agent/accounts/chart"
          style={{ marginLeft: "5px" }}
          className={
            activeTab.startsWith?.("/agent/accounts/chart") ||
            activeTab === "/agent/accounts/chart"
              ? "btn btn-primary"
              : "btn btn-outline-primary"
          }
        >
          <span className="site_family">Accounts</span>
        </Link>

        <Link
          to="/agent/commission"
          style={{ marginLeft: "5px" }}
          className={
            activeTab === "/agent/commission"
              ? "btn btn-primary"
              : "btn btn-outline-primary"
          }
        >
          <span className="site_family">Commission Report</span>
        </Link>

        {(loginUserName !== "") & (UserRole == 1 || UserRole == 2) ? (
          <>
            <Link
              to="/agent/daily-pl-by-users"
              style={{ marginLeft: "5px" }}
              className={
                activeTab === "/agent/daily-pl-by-users"
                  ? "btn btn-primary"
                  : "btn btn-outline-primary"
              }
            >
              <span className="site_family">Daily PL by Users</span>
            </Link>

            <Link
              to="/agent/daily-pl-by-game-type"
              style={{ marginLeft: "5px" }}
              className={
                activeTab === "/agent/daily-pl-by-game-type"
                  ? "btn btn-primary"
                  : "btn btn-outline-primary"
              }
            >
              <span className="site_family">Daily PL by Game Type</span>
            </Link>
          </>
        ) : (
          ""
        )}

        {allowAutoDeposit ? (
          <>
            <Link
              to="/agent/accounts/deposit-request"
              style={{ marginLeft: "5px" }}
              className={
                activeTab === "/agent/accounts/deposit-request"
                  ? "btn btn-primary"
                  : "btn btn-outline-primary"
              }
            >
              <span className="site_family">Auto Deposit Request</span>
            </Link>

            <Link
              to="/agent/accounts/withdrawal-request"
              style={{ marginLeft: "5px" }}
              className={
                activeTab === "/agent/accounts/withdrawal-request"
                  ? "btn btn-primary"
                  : "btn btn-outline-primary"
              }
            >
              <span className="site_family">Withdrawal Requests</span>
            </Link>

            <Link
              to="/agent/accounts/set-payment-details"
              style={{ marginLeft: "5px" }}
              className={
                activeTab === "/agent/accounts/set-payment-details"
                  ? "btn btn-primary"
                  : "btn btn-outline-primary"
              }
            >
              <span className="site_family">Set Payment Details</span>
            </Link>

            <Link
              to={WHATSAPP_SUPPORT_PATH}
              style={{ marginLeft: "5px" }}
              className={
                activeTab === WHATSAPP_SUPPORT_PATH
                  ? "btn btn-success d-inline-flex align-items-center"
                  : "btn btn-outline-success d-inline-flex align-items-center"
              }
            >
              <MessageCircle
                size={16}
                strokeWidth={2}
                style={{ marginRight: 6 }}
              />
              <span className="site_family">Whatsapp Support</span>
            </Link>
          </>
        ) : null}

        {/*<Link to="#" style={{marginLeft:"5px"}} className="btn btn-outline-primary">Auto Mode Setting</Link>*/}
      </div>
    </div>
  );
};

export default NavButton;
